import api from '@/core/api/client';

export interface PlatformSettingsData {
  selfServeSignupEnabled: boolean;
  updatedAt: string;
  updatedByStaffUserId: string | null;
}

export const platformSettingsService = {
  async get(): Promise<PlatformSettingsData> {
    const res = await api.get('/configuracoes/platform-settings');
    // Backend retorna { success: true, data: {...} }
    if (res.data?.success === false) {
      throw new Error(res.data?.message ?? 'Erro ao buscar configurações');
    }
    return res.data?.data ?? res.data;
  },

  async update(data: Partial<PlatformSettingsData>): Promise<PlatformSettingsData> {
    const res = await api.patch('/configuracoes/platform-settings', data);
    if (res.data?.success === false) {
      throw new Error(res.data?.message ?? 'Erro ao atualizar configurações');
    }
    return res.data?.data ?? res.data;
  },
};
